/**
 * @generated SignedSource<<f9bc3e98089d9a5776d7e2eeee3dc3da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftItemImportErrorReason = "NFT_ITEM_IMPORT_ERROR_REASON_DUPLICATE_ID" | "NFT_ITEM_IMPORT_ERROR_REASON_INVALID_MEDIA" | "NFT_ITEM_IMPORT_ERROR_REASON_INVALID_METADATA" | "NFT_ITEM_IMPORT_ERROR_REASON_MEDIA_PROCESSING_ERROR" | "NFT_ITEM_IMPORT_ERROR_REASON_UNKNOWN_ERROR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftItemTileMedia_item$data = {
  readonly importErrorReason: NftItemImportErrorReason | null;
  readonly metadata: {
    readonly media?: {
      readonly mimeType: string | null;
      readonly posterFrameUrl: string | null;
      readonly videoThumb: string | null;
      readonly webUrl: string | null;
    } | null;
    readonly name?: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "NftItemTileMedia_item";
};
export type NftItemTileMedia_item$key = {
  readonly " $data"?: NftItemTileMedia_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileMedia_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileMedia_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "importErrorReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftDigitalArtMetadataMedia",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "webUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "posterFrameUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "videoThumb",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "b641f242e9f51a5612b742306f5f05ee";

export default node;
